import { Box, Button } from '@qga/roo-ui/components';
import styled from '@emotion/styled';
import { themeGet } from 'styled-system';

export const ButtonLink = styled(Button)`
  font-size: 1rem;
  font-weight: 500;
  line-height: 22px;
  width: 93%;
  color: ${themeGet('colors.white')};

  &:hover {
    color: ${themeGet('colors.white')};
    background-color: ${themeGet('colors.red')};
  }
`;

export const ButtonBox = styled(Box)`
  padding-top: 8px;
  padding-bottom: 12px;
  padding-left: 6.5%;
  background-color: ${themeGet('colors.white')};
`;

export const AvailabilityBox = styled(Box)`
  padding-bottom: 12px;
  background-color: ${themeGet('colors.white')};
`;

export const ClickThroughWrapper = styled(Box)`
  pointer-events: none;
`;
